import { jsxs as u, jsx as c } from "react/jsx-runtime";
import { useI18n as y } from "next-localization";
import { NeuAssets as S, NeuIcon as j } from "@hcahealthcaredpx/neutron-react";
const A = ({
  errors: e,
  failureToFetchError: f,
  query: h,
  errorMessageTitle: a,
  errorMessageDescription: l,
  noResultsTitle: p,
  noResultsDescription: m,
  wrapperClassName: x = "pt-6"
}) => {
  const { t } = y(), o = e && e.length > 0 || !!f, d = e && (e == null ? void 0 : e.find((i) => (i == null ? void 0 : i.key) === "GEOCODE_FAILED")), N = o && (e == null ? void 0 : e.some((i) => i.message.includes("A value is required"))), r = t("Search.NotFoundHeadline", {
    query: h
  }), E = d || !o ? /* @__PURE__ */ c(S, { name: "website_search", css: !1, size: "2x", secondary: "support" }) : /* @__PURE__ */ c(j, { name: "error", size: "4x", color: "support" });
  let n = "", s = "";
  return d ? (s = a ?? r, n = l ?? t("Search.NotFoundDescription")) : N ? (s = a ?? t("Locations.Search.NoResult"), n = l ?? t("Locations.Search.TryAgain")) : o ? (s = t("Search.Errors.UnexpectedError"), n = t("Search.Errors.SomethingWentWrong")) : (s = p ?? r, n = m ?? t("Search.NotFoundDescription")), /* @__PURE__ */ u("div", { className: x, children: [
    /* @__PURE__ */ c("div", { className: "d-flex justify-content-center pb-4", children: E }),
    /* @__PURE__ */ u("div", { className: "", children: [
      /* @__PURE__ */ c("h6", { className: "fw-bold d-flex justify-content-center text-center neu-display-4", children: s }),
      typeof n == "string" ? /* @__PURE__ */ c("p", { className: "d-flex justify-content-center text-center pt-1", children: n }) : /* @__PURE__ */ c("div", { className: "d-flex justify-content-center text-center pt-1", children: n })
    ] })
  ] });
};
export {
  A as E
};
